import { takeLatest } from '@redux-saga/core/effects';
import { VEHICLE_CONFIGURATION_ATTRIBUTES_GET_REQUEST, VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS } from '../actions';
import { getVehicleConfigurationAttributesSaga } from './getVehicleConfigurationAttributesSaga';
import { handleAttributesSetToVehicleSaga } from './handleAttributesSetToVehicleSaga';
export function* vehicleConfigurationAttributesRootSaga() {
    yield takeLatest(VEHICLE_CONFIGURATION_ATTRIBUTES_GET_REQUEST, getVehicleConfigurationAttributesSaga);
    yield takeLatest(VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS, handleAttributesSetToVehicleSaga);
}
//# sourceMappingURL=vehicleConfigurationAttributesRootSaga.js.map